import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { ContentService } from '../../../../core/services/content.service';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.css']
})
export class TermsDialogComponent implements OnInit {
  content = '';
  isLoading = false;
  error = '';

  constructor(
    public dialogRef: MatDialogRef<TermsDialogComponent>,
    private contentService: ContentService
  ) { }

  ngOnInit() {
    this.loadContent();
  }

  loadContent() {
    this.isLoading = true;
    this.error = '';
    this.contentService.loadTerms().subscribe(
      (html) => {
        this.content = html;
        this.isLoading = false;
      },
      () => {
        this.error = 'שגיאה בטעינת התקנון';
        this.isLoading = false;
      }
    );
  }

  close() {
    this.dialogRef.close();
  }
}
